module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "prefacepage"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('div', {
    staticClass: "chapterHead"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _c('h2', {
    staticClass: "chapterTitle1",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }, [_c('span', {
    staticClass: "xrefInternal"
  })]), _c('a', {
    attrs: {
      "href": "#/003TOC#preface_page"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallCaps1"
  }, [_vm._v("REFACE")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("W")])]), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("E ALL HAVE OUR")]), _vm._v(" own ideas about how to make the world a better place—and that’s a good thing. Some are called to serve the poor, bringing food, shelter, medicine, and opportunity where the need is greatest. There are men and women devoted especially to the welfare of children, protecting them from violence and exploitation and finding homes for the orphans. Many dedicate themselves to preventing or curing disease, while others labor to protect the environment from pollution or careless development. And by the millions, men and women in America and beyond have set their hearts and minds to the work of preventing cruelty and alleviating the suffering of animals.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There’s an endless division of labor in the good works of society. And though day to day all such worthy causes compete for our attention and support, in the end each are a part of the same fundamental enterprise of humanity. Imagine if we all focused on just one social concern, or even a handful of them. Where would that leave the other vital causes and needs that didn’t make the cut? In a free and philanthropic society, it is for each of us to act and to give as our conscience asks, and in that pluralism of concerns, everybody is covered. In the famous phrase of Edmund Burke, each good cause "), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_vm._v("and group is one more “little platoon” deployed in the work of building and defending a civil society.")])]), _c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("My own little platoon is the Humane Society of the United States. And though I am a friend to many other causes, the cause of helping animals has always had a particular hold on me. I’ve always felt a bond with animals, and I have come to realize that so do people everywhere. At the same time, in more than twenty years of immersion in animal welfare, I’ve also seen incredible cruelty done to animals and heard ever more elaborate arguments offered to justify those abuses. This book is my attempt to confront these contradictions, to disentangle our sometimes conflicted attitudes toward animals, and to suggest a path forward in our own lives and in the life of our country. We all know that cruelty is wrong, but applying this principle in a consistent way can be awfully difficult when so many people and industries misuse animals so routinely and so blithely and often cannot even imagine doing things a different way. In each case, there is a different and better course, and our best guide is the bond with animals—that first impulse to do the decent thing for a fellow creature.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I’ve learned that in the animal-welfare movement no creature is quite forgotten, and there is no animal whose troubles do not matter to someone. Name any species and it has its defenders. It’s not just the “charismatic” species, defended by such groups as the Mountain Lion Foundation, the Snow Leopard Trust, the Whale and Dolphin Conservation Society, the Gorilla Foundation, or Save the Elephants. Countless other groups have been formed to help farm animals, animals in laboratories, overworked animals like donkeys and camels, stray animals and feral cats, and other injured and needy creatures both domesticated and wild.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagex"
    }
  }, [_vm._v("Some people are passionate about animals that most of us have never even heard of. After I completed the manuscript for this book, I came across a story by Kate Murphy in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New York Times")])]), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_vm._v("about purple martins, the largest of North American swallows. Their numbers dropped in the twentieth century because of habitat changes and the introduction of exotic species. Today, all over America, you’ll find nest boxes just for these birds, built by people who appreciate the martins for their beauty and want them to survive. Various blogs and YouTube videos are devoted to the birds, and there is even a Purple Martin Conservation Association, along with the Purple Martin Society of North America and the Purple Martin Preservation Alliance. Some might consider this preoccupation with a single species to be a little much, but I for one am glad for it. I love the idea that some people feel so connected to these creatures and are looking out for them.")])]), _c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I thought I’d heard about every category of animal rehabilitation until I read not long ago about the South Bay Wildlife Rehab, a group whose work includes saving injured and orphaned hummingbirds. Abby Sewell of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Los Angeles Times")]), _vm._v(" describes the work:")])]), _c('div', {
    staticClass: "extract"
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('p', {
    staticClass: "extractTextNoIndent",
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Only a crazy person would do this,” said Terry Masear, 50, who has had as many as 60 hummingbirds at a time flitting around in the cages on her back patio in West Hollywood….")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("During the summer, she takes a three-month hiatus from her job teaching English to foreign professionals at UCLA. Far from being a break, her summers with the hummingbirds entail 15-to 17-hour days of nonstop work…. From 5 a.m. to nightfall, every half hour, pre-fledgling hummingbirds must be fed with a syringe full of a special formula made in Germany. Masear guides a tube down the throats of the little birds, not much larger than bumblebees. Between feedings, she changes feeders for the older birds, cleans cages and monitors the birds’ social interactions.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“You can’t go out to dinner, you can’t go out of town. You don’t have a life,” Masear said….")])])]), _c('p', {
    staticClass: "extractText",
    staticStyle: {
      "text-indent": "5%",
      "margin-left": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("When they are ready to live in the wild, Masear opens the ")])]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v("aviary door and watches the tiny birds spiral hundreds of feet into the air and disappear among the clouds. Even after seeing it hundreds of times, that moment still makes the long hours of drudgery worthwhile, she said: “When you release them, that’s pure joy.”")])]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  })]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("We’re told that not a sparrow falls without his Maker knowing, and millions of animal rescuers and rehabilitators like Terry Masear are paying close attention as well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, the flip side of all this benevolence is that such groups and their labors are needed in the first place. There is so much animal cruelty, homelessness, and suffering, and so much of it is a consequence of human action. In a rational world, the kinder people wouldn’t be so busy dealing with the wreckage left by the cruel and careless.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As harsh as nature is for animals, cruelty comes only from human hands. We are the creature of conscience, aware of the wrongs we do and fully capable of making things right. Our best instincts will always tend in that direction, because a bond with animals is built into every one of us. That bond of kinship and fellow-feeling has been with us through the entire arc of human experience—from our first barefoot steps on the planet through the era of the domestication of animals and into the modern age. For all that sets humanity apart, animals remain “our companions in Creation,” to borrow a phrase from Pope Benedict XVI, bound up with us in the story of life on earth. Every act of callousness toward an animal is a betrayal of that bond. In every act of kindness, we keep faith with the bond. And broadly speaking, the whole mission of the animal-welfare cause is to repair the bond—for their sake and for our own.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v("In our day, there are stresses and fractures of the human-animal bond, and some forces at work would sever it once and for all. They pull us in the wrong direction and away from the decent and honorable code that makes us care for creatures who are entirely at our ")]), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v("mercy. Especially within the last two hundred years, we’ve come to apply an industrial mind-set to the use of animals, too often viewing them as if they were nothing but articles of commerce and the raw material of science, agriculture, and wildlife management. Here, as in other pursuits, human ingenuity has a way of outrunning human conscience, and some things we do only because we can—forgetting to ask whether we should.")])]), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Some object to the abuse of animals because they know that the habits of cruelty and selfishness easily carry over into how we treat one another. Yet in the end, the case for animals stands on its own merits. It needs no other concerns or connections to give it importance. Compassion for animals is a universal value, more so today than ever. Animals matter for their own sake, in their own right, and the wrongs in question are wrongs done to them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Each of the chapters that follow expresses this truth in a different way. Chapter 1 reflects on the human-animal bond, its origins and its varying expressions across time. We are learning so much today about how animals think and feel, and chapter 2 examines that evidence along with the long history of denials among generations of scientists. In chapters 3 through 6, we’ll survey some of the more systematic wrongs inflicted on animals—factory farming, animal fighting, and the abuse of pets and wildlife—and we’ll see how some of these evils are being confronted and overcome through the power of democracy and the rule of law. From there, we’ll venture into the world of the industries and interest groups that seek to hide or explain away the abuse of animals, and we’ll listen carefully to their arguments and excuses. Finally, chapter 8 offers the best counterargument of all, by showing the great and growing possibilities of a humane economy—the new industries and practices that can thrive as we cast off old and cruel ways.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v("Over the years, I have rejoiced in the gains for animal welfare, and I’ve seen my share of setbacks, which you’ll read about here too. ")]), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_vm._v("But the trajectory of progress is unmistakable and undeniable: by ever-larger majorities, the conscience of America is asserting itself. Animal protection has always been a noble cause. Now it’s a winning cause too.")])]), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Today, more than ever, we hold all the cards in our relationship with animals. They have no say in their own fate, and it’s up to us to speak and act on their behalf. International assemblies convene to decide which species will be protected and which will not—quarreling over terms and clauses that can either spare animals by the tens of thousands or destroy them on a similar scale. Humans control the births and deaths of billions of domesticated animals, and often the number of days or hours they are permitted to live. We even shape their very natures and temperament through selective breeding, genetic engineering, and now cloning—taking godlike powers upon ourselves, often with complete disregard for the original designs of God and nature.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_vm._v("When it comes to people and animals, power is asymmetrical, and all the advantages belong to us. Whether it’s a subarctic nursery of newborn seals before the hunters come, or a herd of elephants about to be “culled,” or dogs and cats at the end of their allotted time at a shelter and deemed too costly to keep alive, always their fate depends on our forbearance and our compassion. And one of the themes of human experience, since we first entered the picture ages ago, has been the expansion of that power and the moral test of how we use it—whether cruelly or kindly, selfishly or justly, pridefully or humbly. There have always been people and groups, in every time and place, who seek to dismiss and belittle the cause of protecting animals, as if the other creatures of the earth were just an obstacle to human progress that needs to be cleared away, subdued, or even wiped out as we decide. And there have always been those others who raised a clear voice in defense of animals, unafraid to question ")]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v("old assumptions, unworthy traditions, and practices and industries that can no longer hold up to reason or conscience.")])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Millions are carrying on in that same spirit of challenging, questioning, and calling cruelty by its name. The battle is unfolding on many fronts, as described in the pages to follow. In the end, whenever we humans find it in ourselves to help powerless and vulnerable creatures, we are both affirming their goodness and showing our own. In that way, their cause is also the cause of humanity, and this book is your invitation to join it.")])])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6913cae0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004-prefacepage.vue
// module id = 66
// module chunks = 0